import { useMemo, type ReactNode } from 'react';
import MultiSelectPopover from '@/components/ui/multi-select-popover';

export interface Option {
  id: number;
  name: string;
  // NOTE: 旧UI互換で残すが、現行Popoverでは未使用
  colorHex?: string;
}

interface MultiSelectProps {
  options: Option[];
  value: number[];
  onChange: (value: number[]) => void;
  placeholder?: string;
  disabled?: boolean;
  searchable?: boolean;
  align?: 'start' | 'end';
  columns?: 1 | 2 | 3;
  className?: string;
  header?: ReactNode;
  footer?: ReactNode;
  variant?: 'grid' | 'list';
  matchTriggerWidth?: boolean;
}

export default function MultiSelect({
  options,
  value,
  onChange,
  placeholder = '選択してください',
  disabled = false,
  searchable = false,
  align = 'start',
  columns = 1,
  className,
  header,
  footer,
  variant,
  matchTriggerWidth = true,
}: MultiSelectProps) {
  const normalizedValue = useMemo(
    () => (value || []).map((v) => Number(v)).filter((v) => Number.isFinite(v)),
    [value]
  );

  return (
    <MultiSelectPopover
      options={(options || []).map((opt) => ({ id: opt.id, name: opt.name }))}
      value={normalizedValue}
      onChange={(next) => {
        const numeric = next.map((v) => Number(v)).filter((v) => Number.isFinite(v));
        onChange(numeric);
      }}
      placeholder={placeholder}
      disabled={disabled}
      searchable={searchable}
      align={align}
      columns={columns}
      className={className}
      header={header}
      footer={footer}
      variant={variant}
      matchTriggerWidth={matchTriggerWidth}
    />
  );
}
